import { gql, useQuery } from '@apollo/client';
import { isLoggedIn } from '../utils/auth';
import { useSDMCustomerContext, ISDMCustomerContext } from '@ldp/sdm-contexts';
import { useEffect, useState } from 'react';

export const GET_USER_PCO_DATA = gql`
  query GetUserPcoData {
    user {
      pcoData {
        loyaltyMemberId
        optimumCardBalancePoints
        redeemableValueForHousehold
      }
    }
  }
`;

const useGetUserPcoData = (): {
  userPcoData?: { loyaltyMemberId: string; optimumCardBalancePoints: number; redeemableValueForHousehold: number };
} => {
  const [shouldSkipQuery, setShouldSkipQuery] = useState(false);
  const { setPcOptimumAccount } = useSDMCustomerContext() as ISDMCustomerContext;

  const loggedInStatus = !!isLoggedIn();

  useEffect(() => {
    if (!loggedInStatus) {
      setPcOptimumAccount({
        memberId: '',
        walletId: '',
        householdId: '',
        points: {
          balance: 0,
          dollarsRedeemable: 0,
          dollarsRedeemedLifetime: 0,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedInStatus]);

  const { data } = useQuery(GET_USER_PCO_DATA, {
    skip: !loggedInStatus || shouldSkipQuery,
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      if (data) {
        const pcoData = data?.user?.pcoData;
        const { loyaltyMemberId, optimumCardBalancePoints, redeemableValueForHousehold } = pcoData;
        //memberId and walletId are the same values
        const pcoMemberId = loyaltyMemberId !== null ? loyaltyMemberId : '';
        const PcOptimumData = {
          memberId: pcoMemberId,
          householdId: '',
          walletId: pcoMemberId,
          points: {
            balance: optimumCardBalancePoints,
            dollarsRedeemable: redeemableValueForHousehold,
            //default at 0 since value not available this gql query
            dollarsRedeemedLifetime: 0,
          },
        };
        setPcOptimumAccount(PcOptimumData);
        setShouldSkipQuery(true);
      }
      return;
    },
  });

  return {
    userPcoData: data?.user?.pcoData,
  };
};

export default useGetUserPcoData;
